module.exports = "/_next/static/images/img-portfolio-earth-4cca37fc641f34f68f3698f09f6fc0d8.svg";